import { getApiBaseURL } from '@/utils/environment';
import advisor from './advisor';
import auth from './auth';
import axios from 'axios';
import company from './company';
import conversation from './conversation';
import exportTask from './exportTask';
import extractedDocument from './extractedDocument';
import firm from './firm';
import help from './help';
import integration from './integration';
import linkedAccount from './linkedAccount';
import note from './note';
import parse from 'url-parse';
// import posthog from './posthog';
import priorYearItem from './priorYearItem';
import priorYearItemsMatch from './priorYearItemsMatch';
import questionnaire from './questionnaire';
import questionnaireTemplate from './questionnaireTemplate';
import reviewAndExport from './reviewAndExport';
import reminder from './reminder';
import report from './report';
import resource from './resource';
import scheduler from './scheduler';
import signatureRequest from './signatureRequest';
import store from '@/vuex';
import taxReturn from './taxReturn';
import taxReturnAdditionalRecipient from './taxReturnAdditionalRecipient';
import taxReturnIdentityVerification from './taxReturnIdentityVerification';
import timesheet from './timesheet';
import documentDropOff from './documentDropOff';
import user from './user';
import Vue from 'vue';
import VueAxios from 'vue-axios';

Vue.use(VueAxios, axios);

axios.defaults.baseURL = getApiBaseURL();
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common.Accept = 'application/json';
axios.defaults.timeout = 120000;
axios.defaults.maxBodyLength = Infinity;
axios.defaults.maxContentLength = Infinity;

axios.interceptors.request.use(async config => {
  const isEmbed = parse(window.location.href).pathname === '/embed';
  const user = await store.dispatch('getFirebaseUser');

  if (!user) {
    return config;
  }

  if (
    config.url.startsWith('http') &&
    !config.url.startsWith(process.env.API_URL)
  ) {
    return config;
  }

  const token = await store.dispatch('getToken');
  if (token && !isEmbed) {
    // eslint-disable-next-line no-param-reassign
    // config.headers.Authorization = `Bearer ${token}`;
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = token;
  }
  return config;
});

export default {
  // posthog,
  advisor,
  auth,
  company,
  conversation,
  exportTask,
  extractedDocument,
  firm,
  help,
  integration,
  linkedAccount,
  note,
  reviewAndExport,
  priorYearItem,
  priorYearItemsMatch,
  questionnaire,
  questionnaireTemplate,
  reminder,
  report,
  resource,
  scheduler,
  signatureRequest,
  taxReturn,
  taxReturnAdditionalRecipient,
  taxReturnIdentityVerification,
  timesheet,
  documentDropOff,
  user,
};
